export default __webpack_public_path__ + "src/images/packages/maliba-lodge/0200a74e09dd67d37a36b9d2700944b6-5.jpeg";